import { Injectable } from '@angular/core';

@Injectable()
export class TrnDischargelistService {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/trn-dischargelist/trn-dischargelist.service.ts